<template>
  <el-dialog
    title="帮助中心"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="closeDialog">
    <span>留言</span>
    <span slot="footer" class="dialog-footer">
  </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['dialogVisible'],
  data () {
    return {
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/user/Help.vue